"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _ChooseAccount = _interopRequireDefault(require("../ChooseAccount"));
var _Validators = require("../../Utility/Validators");
var _VerifyDetails = _interopRequireDefault(require("../VerifyDetails/VerifyDetails"));
var _constants = require("../../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PostPlaid = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PostPlaid, _React$Component);
  var _super = _createSuper(PostPlaid);
  function PostPlaid(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PostPlaid);
    _this = _super.call(this, props);
    _this.onAccountChange = _this.handleAccountChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(PostPlaid, [{
    key: "handleAccountChange",
    value: function handleAccountChange(event, account) {
      var eventProps = {
        field: event.target.name,
        value: event.target.value,
        type: 'click',
        account: account
      };
      var onAccountChange = this.props.onAccountChange;
      onAccountChange(event, eventProps);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _onChange;
      var eventProps = {
        field: event.target.name,
        value: event.target.value
      };
      var inputValueValidation = (0, _Validators.validateInputContent)(eventProps.field, eventProps.value);
      if (inputValueValidation) {
        return;
      }
      var onChange = this.props.onChange;
      onChange(event, (_onChange = {}, (0, _defineProperty2["default"])(_onChange, event.target.name, eventProps), (0, _defineProperty2["default"])(_onChange, "type", 'change'), (0, _defineProperty2["default"])(_onChange, "field", event.target.name), _onChange));
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var _eventProps;
      var value = event.target.value;
      var eventProps = (_eventProps = {
        field: event.target.name
      }, (0, _defineProperty2["default"])(_eventProps, event.target.name, {
        field: event.target.name,
        value: value
      }), (0, _defineProperty2["default"])(_eventProps, "type", 'blur'), _eventProps);
      var onChange = this.props.onChange;
      var field = eventProps.field;
      var _this$props = this.props,
        firstName = _this$props.firstName,
        lastName = _this$props.lastName,
        accountNumber = _this$props.accountNumber,
        confirmAccountNumber = _this$props.confirmAccountNumber,
        routingNumber = _this$props.routingNumber,
        selectedAccount = _this$props.selectedAccount;
      var dataModel = {
        firstName: firstName,
        lastName: lastName,
        accountNumber: accountNumber,
        confirmAccountNumber: confirmAccountNumber,
        routingNumber: routingNumber,
        selectedAccount: selectedAccount
      };
      var error = (0, _Validators.singleValidator)({
        field: field,
        value: value
      }, dataModel);
      if (Object.keys(error).length > 0) {
        eventProps.error = error;
      }
      onChange(event, eventProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        _this$props2$headerTe = _this$props2.headerText,
        account = _this$props2$headerTe.account,
        single = _this$props2$headerTe.single,
        verifyHeaderText = _this$props2$headerTe.verify,
        supportedAccounts = _this$props2.supportedAccounts,
        unsupportedAccounts = _this$props2.unsupportedAccounts,
        unsupportedAccountDisclaimer = _this$props2.unsupportedAccountDisclaimer,
        selectedAccount = _this$props2.selectedAccount,
        onBankChange = _this$props2.onBankChange,
        needToUseDifferentBankLabel = _this$props2.needToUseDifferentBankLabel,
        needToUseDifferentBankAnchor = _this$props2.needToUseDifferentBankAnchor,
        showName = _this$props2.showName,
        showAccount = _this$props2.showAccount,
        showRouting = _this$props2.showRouting,
        errors = _this$props2.errors,
        firstName = _this$props2.firstName,
        lastName = _this$props2.lastName,
        accountNumber = _this$props2.accountNumber,
        confirmAccountNumber = _this$props2.confirmAccountNumber,
        routingNumber = _this$props2.routingNumber;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "post-plaid"
      }, /*#__PURE__*/_react["default"].createElement(_ChooseAccount["default"], {
        supportedAccounts: supportedAccounts,
        unsupportedAccounts: unsupportedAccounts,
        headerText: supportedAccounts.length === 1 ? single : account,
        selectedAccount: selectedAccount,
        changeBank: onBankChange,
        onAccountChange: this.onAccountChange,
        unsupportedAccountDisclaimer: unsupportedAccountDisclaimer,
        changeBankLabel: needToUseDifferentBankLabel,
        changeBankAnchor: needToUseDifferentBankAnchor
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Divider, {
        kind: "light",
        style: {
          borderTop: '1px solid #EDF3F7'
        }
      }), (showName || showAccount || showRouting) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_VerifyDetails["default"], {
        headerText: verifyHeaderText,
        institution: supportedAccounts[0].institutionName,
        errors: errors,
        firstName: _objectSpread(_objectSpread({}, firstName), {}, {
          onChange: this.onChange,
          onBlur: this.onBlur,
          errors: errors.firstName
        }),
        lastName: _objectSpread(_objectSpread({}, lastName), {}, {
          onChange: this.onChange,
          onBlur: this.onBlur,
          errors: errors.lastName
        }),
        accountNumber: _objectSpread(_objectSpread({}, accountNumber), {}, {
          onChange: this.onChange,
          onBlur: this.onBlur,
          errors: errors.accountNumber
        }),
        confirmAccountNumber: _objectSpread(_objectSpread({}, confirmAccountNumber), {}, {
          onChange: this.onChange,
          onBlur: this.onBlur,
          errors: errors.confirmAccountNumber
        }),
        routingNumber: _objectSpread(_objectSpread({}, routingNumber), {}, {
          onChange: this.onChange,
          onBlur: this.onBlur,
          errors: errors.routingNumber
        }),
        showName: showName,
        showAccount: showAccount,
        showRouting: showRouting,
        selectedAccount: selectedAccount
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Divider, {
        kind: "light",
        style: {
          borderTop: '1px solid #EDF3F7'
        }
      })));
    }
  }]);
  return PostPlaid;
}(_react["default"].Component);
PostPlaid.propTypes = {
  /**
   * An object containing three (3) properties that represent the header text for the internal components: `account` & `verify` & `single`
   * pass all three headers and PostPlaid will display the relevant headers as per data.
   */
  headerText: (0, _propTypes.shape)({
    account: _propTypes.string,
    single: _propTypes.string,
    verify: _propTypes.string
  }).isRequired,
  /**
   * A URL that will be used to allow users to reselect a different bank
   */
  onBankChange: _propTypes.func.isRequired,
  /**
   * custom text in label to be displayed in change bank option,
   * if is empty default text will be displayed
   */
  needToUseDifferentBankLabel: _propTypes.string,
  /**
   * custom text in button to be displayed in change bank option,
   * if is empty default text will be displayed
   */
  needToUseDifferentBankAnchor: _propTypes.string,
  /**
   * A function that is called when selecting an account
   */
  onAccountChange: _propTypes.func.isRequired,
  /**
   * An array of supported accounts to display
   */
  supportedAccounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })).isRequired,
  /**
   * An array of unsupported accounts
   */
  unsupportedAccounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })).isRequired,
  /**
   * custom text to be displayed as disclaimer for unsupported account,
   * if is empty default text will be displayed
   */
  unsupportedAccountDisclaimer: _propTypes.string,
  /**
   * An object that represents the selected account
   */
  selectedAccount: (0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }).isRequired,
  /**
   * A boolean on whether to display the VerifyName form
   */
  showName: _propTypes.bool.isRequired,
  /**
   * A boolean on whether to display the VerifyAccount form
   */
  showAccount: _propTypes.bool.isRequired,
  /**
   * A boolean on whether to display the VerifyRouting form
   */
  showRouting: _propTypes.bool.isRequired,
  /**
   * A function that is called when the form fields are changed
   */
  onChange: _propTypes.func.isRequired,
  /**
   * An object to provide properties to the First Name field
   */
  firstName: (0, _propTypes.shape)({
    value: _propTypes.string,
    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: _propTypes.object
  }).isRequired,
  /**
   * An object to provide properties to the Last Name field
   */
  lastName: (0, _propTypes.shape)({
    value: _propTypes.string,
    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: _propTypes.object
  }).isRequired,
  /**
   * An object to provide properties to the Account Number field
   */
  accountNumber: (0, _propTypes.shape)({
    value: _propTypes.string,
    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: _propTypes.object
  }).isRequired,
  /**
   * An object to provide properties to the Confirm Account Number field
   */
  confirmAccountNumber: (0, _propTypes.shape)({
    value: _propTypes.string,
    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: _propTypes.object
  }).isRequired,
  /**
   * An object to provide properties to the Routing Number field
   */
  routingNumber: (0, _propTypes.shape)({
    value: _propTypes.string,
    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: _propTypes.object
  }).isRequired,
  /**
   * An object that represents any/all errors
   */
  errors: _propTypes["default"].objectOf(_propTypes["default"].object)
};
PostPlaid.defaultProps = {
  errors: {},
  unsupportedAccountDisclaimer: _constants.UNSUPPORTED_ACCOUNTS_DISCLAIMER,
  needToUseDifferentBankLabel: _constants.RESELECT_DIFFERENT_BANK_LABEL,
  needToUseDifferentBankAnchor: _constants.RESELECT_DIFFERENT_BANK_ANCHOR
};
var _default = PostPlaid;
exports["default"] = _default;
